import React, { Component, ReactElement } from 'react'
import { LanguageContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { DirectoryListFeatureGate } from '../Guards/DirectoryListFeatureGate'
import { DirectoryList } from '../Components/Organisms/DirectoryList/DirectoryList'

/**
 * Routed Directory list page.
 */
@Route(RouteID.DIRECTORY)
export class DirectoryListPage extends Component {
    /**
     * Renders the Directory admin list page content tree.
     *
     * @returns Directory list page tree.
     */
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.DIRECTORY}>
                <DirectoryListFeatureGate>
                    <LanguageContextProvider>
                        <DirectoryList />
                    </LanguageContextProvider>
                </DirectoryListFeatureGate>
            </RouteGuard>
        )
    }
}
